import Vue from 'vue'
import App from './App.vue'
import "./assets/app.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Notifications from 'vue-notification';
import 'animate.css';
import store from './store'
import vuetify from './plugins/vuetify'

Vue.use(Notifications)
Vue.config.productionTip = false

new Vue({
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
